import React from 'react';
import { Routes, Route, Navigate, Link, useLocation } from 'react-router-dom';
import { useSession, useAuth, supabase } from './auth/supabase';
import SignIn from './pages/SignIn';
import PatientsList from './pages/PatientsList';
import PatientDetail from './pages/PatientDetail';
import styles from './App.module.css';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import TemplatesPage from './pages/TemplatesPage';

function RequireAuth({ children }) {
  const { session, initializing } = useAuth();
  const location = useLocation();
  if (initializing) {
    return null; // wait for session to hydrate to prevent redirect on refresh
  }
  if (!session) {
    return <Navigate to="/signin" replace state={{ from: location }} />;
  }
  return children;
}

export default function App() {
  return (
    <div className={styles.app}>
      <Layout>
      <Routes>
        <Route path="/signin" element={<SignIn />} />
        <Route path="/" element={<Navigate to="/patients" replace />} />
        <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
        <Route path="/patients" element={<RequireAuth><PatientsList /></RequireAuth>} />
        <Route
          path="/patients/:id"
          element={
            <RequireAuth>
              <PatientDetail />
            </RequireAuth>
          }
        />
        <Route path="/templates" element={<RequireAuth><TemplatesPage /></RequireAuth>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </Layout>
    </div>
  );
}

// Header auth moved into Layout
